export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-200/20 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-200/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-6">
                <i className="ri-fire-line"></i>
                <span>免费高清 · 海量资源</span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
                黄桃视频
                <br />
                <span className="text-primary-500">免费高清在线观影平台</span>
              </h1>

              <p className="mt-4 text-lg md:text-xl text-primary-600 font-heading font-medium">
                随时随地，想看就看
              </p>

              <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                黄桃视频是与樱花视频、糖豆视频、蘑菇视频同类的优质视频平台，致力于为广大影迷提供免费高清在线观看服务。
                覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日更新热门资源，不缓冲不卡顿，
                支持网站与APP双端访问，是您追剧观影的首选入口。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-500"></span>
                  <span className="text-sm text-foreground-600">每日更新 3000+ 部</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-sm text-foreground-600">高清画质 不缓冲</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                  <span className="text-sm text-foreground-600">全终端覆盖 随时看</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-base font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-2-line text-lg"></i>
                  下载APP立即观看
                </a>
                <a
                  href="#cards"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-100 text-foreground-700 text-base font-semibold rounded-lg hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-background-200/70"
                >
                  <i className="ri-film-line text-lg"></i>
                  浏览影视分类
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end">
              <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20peach-orange%20and%20coral%20colored%20abstract%20digital%20art%20with%20soft%20flowing%20curves%20and%20cinematic%20atmosphere%2C%20modern%20streaming%20platform%20vibe%2C%20subtle%20gradient%20waves%2C%20entertainment%20theme%2C%20clean%20minimalist%20design%2C%20warm%20inviting%20color%20palette%20with%20gentle%20light%20effects%2C%20no%20text%2C%20no%20faces%2C%20smooth%20organic%20shapes%2C%20high%20quality%20digital%20illustration&width=960&height=720&seq=huangtao-hero-visual&orientation=landscape"
                  alt="黄桃视频在线观影平台主视觉"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/15 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/40 to-transparent">
                  <div className="flex items-center gap-3">
                    <span className="w-12 h-12 rounded-xl bg-primary-500/90 flex items-center justify-center">
                      <i className="ri-play-fill text-background-50 text-2xl"></i>
                    </span>
                    <div>
                      <p className="text-background-50 text-sm font-semibold">黄桃视频</p>
                      <p className="text-background-200 text-xs">免费高清 · 畅享无限</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}